import React, { useContext } from 'react';
import { ConfigContext } from './internals';

export function useConfig() {
  const storeInstance = useContext(ConfigContext);

  if (!storeInstance) {
    throw new Error('You forgot to add <ConfigProvider> as a parent.');
  }

  return storeInstance;
}
